<template>
    <div>
        <div class="flex jcbc p14-9">

            <div class="flex w66 alc">
                <el-select v-model="isuse" size="mini" @change="searchFun" style="margin-right: 9px;width:110px; ">
                    <el-option v-for="item in isuseList" :key="item.key" :label="item.label" :value="item.key"></el-option>
                </el-select>
<!--                <el-cascader size="mini" v-model="qyvalue" filterable clearable :options="gjList" :props="qyprops" @change="handleChange"style="margin-right: 9px; "></el-cascader>-->
                <el-select  v-model="i_national" @change="gjChange" filterable clearable  size="mini" style="margin-right: 9px;width:110px; " filterable>
                    <el-option v-for="item in gjList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <el-select  v-model="i_province" @change="searchFun" filterable clearable  size="mini" style="margin-right: 9px;width:110px; " filterable>
                    <el-option v-for="item in sfList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <el-input  class="marr4" style=""  v-model="vc_search" placeholder="请输入港口名称" clearable size="mini"style="margin-right: 9px;width:110px; "></el-input>
                <el-button class="marr4" icon="el-icon-search" circle  @click="searchFun" size="mini"></el-button>
            </div>
            <el-button class="marB10" @click="addFun" :class="baseerp+'btn'" size="mini">
                新增
            </el-button>
        </div>

        <el-table
                class="mrt10" ref="table" size="mini" :height="tableHeight" border :data="tableData"
                :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column  prop="i_id" label="港口ID" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_name" label="港口名称" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_ename" label="英文名称" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_national" label="归属国家" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_province" label="归属省份" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="isuse" label="是否启用" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.isuse==0?'否':'是'}}</span>
                </template>
            </el-table-column>
            <el-table-column  prop="vc_lruname" label="录入人" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="dt_createtime" label="录入时间" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                    <el-button  size="mini" type="text" @click="detailsFun(scope.row)" >详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  style="margin-top: 10px;text-align: right" background @current-change="pageCurrentChange" layout="total,prev, pager, next"
                        :current-page.sync="currentPage" :total="total" :page-size="pageSize">
        </el-pagination>
        <div :class="baseerp+'div'">
            <el-dialog :title="detailTitle" width="500"  :visible.sync="dialogVisible"
                       :close-on-click-modal="false" @close="closeFun">
                <port-page :data="propData" v-if="dialogVisible" @close="closeFun"></port-page>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";
    import PortPage from "./PortPage";

    export default {
        name: "index",
        components: {PortPage},
        props: {},
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                tableData:[],
                currentPage:1,
                pageSize:20,
                total:0,
                dialogBankVisible:false,
                dialogVisible:false,
                propData:{},
                detailTitle:'',
                isuseList:[{key:0,label:'已禁用'},{key:1,label:'已启用'}],
                isuse:1,
                vc_search:'',
                gjList:[],
                sfList:[],
                qyvalue:[],
                i_national:null,
                i_province:null,
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.$nextTick(() => {
                this.onResize();
            })
            this.getSeaPorts()
            this.getAreaTree()
        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.2;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            searchFun(){
                this.currentPage=1;
                this.getSeaPorts()
            },
            gjChange(){
                if(this.i_national)this.getAreaTree(this.i_national);
                this.sfList=[]
                this.i_province=''
                this.currentPage=1
                this.getSeaPorts()
            },
            addFun(){
                this.dialogVisible=true;
                this.detailTitle='新增港口';
                this.propData={
                    i_id:0
                }
            },
            detailsFun(val){
                this.dialogVisible=true;
                this.detailTitle='编辑港口';
                this.propData=val
            },
            closeFun(type='back'){
                this.dialogVisible=false;
                if(type=='save'){
                    this.currentPage=1
                    this.getSeaPorts()
                }
                this.propData=null
            },
            pageCurrentChange(val){
                this.currentPage=val;
                this.getSeaPorts()
            },
            async getSeaPorts(){
                let param={
                    // isuse:this.isuse,
                    vc_search:this.vc_search,
                    pageSize: 20,
                    currentPage:this.currentPage,
                    i_national:this.i_national,
                    i_province:this.i_province,
                    isuse:this.isuse
                };
                let res=await API.getSeaPorts(param);
                if ( res.code == 1 ){
                    this.tableData=res.data.seaPortList;
                    this.total=res.data.total;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            async getAreaTree(i_id=0){
                let param = {
                    i_pid:i_id,
                    isuse:1,
                };
                let res = await API.getAreaTree(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        if (i_id==0){
                            this.gjList=   res.data
                        }else{
                            this.sfList=   res.data
                        }
                        // res.data.map(one=>{
                        //     let hash=one;
                        //     hash.leaf= one.i_level<1?!one.hassub:true;
                        //     hash.i_level= one.i_level;
                        //     hash.label= one.vc_name;
                        //     hash.value= one.i_id;
                        //     list.push(hash);
                        // })
                    }
                    // return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
    }
    .jcbc{
        justify-content: space-between;
    }
    .p14-9{
        padding: 14px 9px;
    }
</style>